/* Previously viewed — desktop floating card + drawer slot on mobile */
(function () {
  "use strict";

  var STORAGE_KEY = "theartfolio_recently_viewed";
  var DISMISS_KEY = "theartfolio_recently_viewed_dismissed";
  var MAX_ITEMS = 12;
  var MOBILE_MQ = "(max-width: 680px)";
  var DESKTOP_AUTO_HIDE_MS = 5500;

  function ready(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  function isMobile() {
    return window.matchMedia(MOBILE_MQ).matches;
  }

  function formatMoney(cents) {
    if (window.theme && typeof window.theme.formatMoney === "function") {
      return window.theme.formatMoney(cents);
    }
    return "£" + ((Number(cents) || 0) / 100).toFixed(2);
  }

  function readList() {
    try {
      var parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function writeList(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list.slice(0, MAX_ITEMS)));
    } catch (e) {}
  }

  function readDismissed() {
    try {
      return sessionStorage.getItem(DISMISS_KEY) || "";
    } catch (e) {
      return "";
    }
  }

  function writeDismissed(handle) {
    try {
      sessionStorage.setItem(DISMISS_KEY, handle || "");
    } catch (e) {}
  }

  function productImage(product) {
    if (!product) return "";
    if (product.featured_image) {
      if (typeof product.featured_image === "string") return product.featured_image;
      return product.featured_image.src || product.featured_image.url || "";
    }
    if (product.images && product.images[0]) {
      var img = product.images[0];
      return typeof img === "string" ? img : (img.src || img.url || "");
    }
    return "";
  }

  function normalizeCurrent(raw) {
    if (!raw || !raw.handle) return null;
    var image = productImage(raw);
    if (image && image.indexOf("//") === 0) image = "https:" + image;
    var url = raw.url || ("/products/" + raw.handle);
    try {
      var host = document.querySelector("[data-frame-visualiser-host], [data-product]");
      var visualiser = host && (host.matches("[data-frame-visualiser]") ? host : host.querySelector("[data-frame-visualiser]"));
      var api = visualiser && visualiser.frameVisualiser;
      if (api && typeof api.getConfiguredUrl === "function") {
        url = api.getConfiguredUrl();
      }
    } catch (e) {}
    var summary = "";
    try {
      var optionsApi = document.querySelector("[data-frame-visualiser]");
      var lookApi = optionsApi && optionsApi.frameVisualiser;
      if (lookApi && typeof lookApi.getOptions === "function" && window.TheArtfolioFavourites) {
        summary = window.TheArtfolioFavourites.optionsSummary(lookApi.getOptions());
      }
    } catch (e2) {}
    return {
      handle: String(raw.handle),
      url: url,
      title: raw.title || "Untitled",
      vendor: raw.vendor || "",
      image: image,
      priceMin: raw.price_min != null ? raw.price_min : raw.price,
      summary: summary
    };
  }

  function pushCurrent(item) {
    if (!item || !item.handle) return;
    var list = readList().filter(function (entry) {
      return entry && entry.handle !== item.handle;
    });
    list.unshift(item);
    writeList(list);
  }

  function previousItem(currentHandle) {
    var list = readList();
    for (var i = 0; i < list.length; i += 1) {
      if (list[i] && list[i].handle && list[i].handle !== currentHandle) {
        return list[i];
      }
    }
    return null;
  }

  function fillMedia(container, src, size) {
    if (!container) return;
    container.innerHTML = "";
    if (!src) return;
    var img = document.createElement("img");
    img.src = src;
    img.alt = "";
    img.width = size || 144;
    img.height = size || 180;
    img.loading = "lazy";
    container.appendChild(img);
  }

  function metaText(item) {
    var bits = [];
    if (item.summary) bits.push(item.summary);
    else if (item.vendor) bits.push(item.vendor);
    if (item.priceMin != null && item.priceMin !== "") {
      bits.push("from " + formatMoney(item.priceMin));
    }
    return bits.join(" · ");
  }

  ready(function () {
    var root = document.querySelector("[data-recently-viewed]");
    var dataEl = document.querySelector("[data-product-json]");
    if (!dataEl) return;

    var raw;
    try {
      raw = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var current = normalizeCurrent(raw);
    if (!current) return;

    var prev = previousItem(current.handle);
    var dismissed = readDismissed();
    var showPrev = !!(prev && prev.handle !== dismissed);
    var cardAutoHidden = false;
    var hideTimer = null;

    var link = root && root.querySelector("[data-recently-viewed-link]");
    var media = root && root.querySelector("[data-recently-viewed-media]");
    var title = root && root.querySelector("[data-recently-viewed-title]");
    var meta = root && root.querySelector("[data-recently-viewed-meta]");
    var dismissBtn = root && root.querySelector("[data-recently-viewed-dismiss]");

    var drawerRecent = document.querySelector("[data-mood-recent]");
    var drawerLink = document.querySelector("[data-mood-recent-link]");
    var drawerMedia = document.querySelector("[data-mood-recent-media]");
    var drawerTitle = document.querySelector("[data-mood-recent-title]");
    var drawerMeta = document.querySelector("[data-mood-recent-meta]");
    var tab = document.querySelector("[data-mood-feel-tab]");

    function clearHideTimer() {
      if (!hideTimer) return;
      window.clearTimeout(hideTimer);
      hideTimer = null;
    }

    function closeCard() {
      if (!root) return;
      clearHideTimer();
      root.setAttribute("data-open", "false");
      window.setTimeout(function () {
        root.hidden = true;
      }, 280);
    }

    function scheduleAutoHide() {
      clearHideTimer();
      if (!root || isMobile() || !showPrev || cardAutoHidden) return;
      hideTimer = window.setTimeout(function () {
        hideTimer = null;
        cardAutoHidden = true;
        closeCard();
      }, DESKTOP_AUTO_HIDE_MS);
    }

    function populateTargets(item) {
      if (link && title && meta && media) {
        link.href = item.url;
        title.textContent = item.title;
        meta.textContent = metaText(item);
        fillMedia(media, item.image, 144);
      }
      if (drawerRecent && drawerLink && drawerTitle && drawerMeta) {
        drawerLink.href = item.url;
        drawerTitle.textContent = item.title;
        drawerMeta.textContent = metaText(item);
        fillMedia(drawerMedia, item.image, 120);
        drawerRecent.hidden = false;
      }
    }

    function syncPresentation() {
      if (tab) {
        tab.setAttribute(
          "aria-label",
          isMobile() ? "Your picks: mood and previously viewed" : "How does this feel?"
        );
      }
      if (!showPrev) {
        clearHideTimer();
        if (drawerRecent) drawerRecent.hidden = true;
        if (root) {
          root.hidden = true;
          root.setAttribute("data-open", "false");
        }
        return;
      }
      if (drawerRecent) drawerRecent.hidden = false;
      if (!root) return;
      if (isMobile() || cardAutoHidden) {
        clearHideTimer();
        root.hidden = true;
        root.setAttribute("data-open", "false");
      } else {
        root.hidden = false;
        window.requestAnimationFrame(function () {
          root.setAttribute("data-open", "true");
          scheduleAutoHide();
        });
      }
    }

    if (showPrev) populateTargets(prev);

    if (dismissBtn) {
      dismissBtn.addEventListener("click", function () {
        if (prev) writeDismissed(prev.handle);
        showPrev = false;
        cardAutoHidden = true;
        if (drawerRecent) drawerRecent.hidden = true;
        closeCard();
      });
    }

    if (root) {
      root.addEventListener("mouseenter", clearHideTimer);
      root.addEventListener("mouseleave", function () {
        if (!cardAutoHidden && showPrev && !isMobile()) scheduleAutoHide();
      });
      root.addEventListener("focusin", clearHideTimer);
      root.addEventListener("focusout", function (event) {
        if (root.contains(event.relatedTarget)) return;
        if (!cardAutoHidden && showPrev && !isMobile()) scheduleAutoHide();
      });
    }

    window.addEventListener("resize", syncPresentation);
    syncPresentation();

    window.setTimeout(function () {
      var refreshed = normalizeCurrent(raw);
      if (refreshed) pushCurrent(refreshed);
      else pushCurrent(current);
    }, 400);
  });
})();
